import MoreAction from "./MoreAction";
import styleUser from "./User.module.css";

export const useColumns = ({ refetch}) => {
  const columns = [
    {
      title: "S.N",
      render: ({ sn }) => {
        return <div>{sn}</div>;
      },
    },
    {
      title: "Name",
      render: ({ first_name, last_name }) => {
        return <div>{`${first_name} ${last_name}`}</div>;
      },
    },
    {
      title: "Username/Email",
      render: ({ username, email }) => {
        return <div>{username || email}</div>;
      },
    },
    {
      title: "Role",
      render: ({ groups }) => {
        return <div>{groups?.[0]?.role}</div>;
      },
    },
    {
      title: "Editor",
      render: ({ editor, groups }) => {
        if (groups?.[0]?.role !== "Viewer") return <div>—</div>;
        if (!editor) return <div>—</div>;
        if (typeof editor === "string") return <div>{editor}</div>;
        const name = [editor.first_name, editor.last_name]
          .filter(Boolean)
          .join(" ")
          .trim();
        return <div>{name || editor.email || editor.username || "—"}</div>;
      },
    },
    {
      title: "Organization",
      render: ({ organization }) => {
        return <div>{organization || "—"}</div>;
      },
    },
    {
      title: "Status",
      render: ({ is_active }) => {
        return (
          <div className={is_active ? styleUser.active : styleUser.inactive}>
            {is_active ? "Active" : "Inactive"}
          </div>
        );
      },
    },
    {
      title: "Action",
      render: (row) => {
        return <MoreAction refetch={refetch} row={row} />;
      },
    },
  ];
  return { columns };
};
